// @ts-nocheck
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import { chain, ExecuteOnSuccessCallback } from "@insite/client-framework/Store/Pages/UserList/Handlers/CreateUser";
import { addToChainAfter } from "@toolkit/Modules/client-framework/HandlerCreator";

addToChainAfter(chain, ExecuteOnSuccessCallback, props => {
    const state = props.getState();
    const userSetupUrl = getPageLinkByPageType(state, "UserSetupPage")?.url;

    if (props.apiResult.successful && userSetupUrl) {
        window.location.href = `${userSetupUrl}?userId=${props.apiResult.result.id}`;
    }
});
